module.exports = __webpack_public_path__ + "static/media/marketing.c39fb0c9.jpg";